import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import LendingSoftware from "./LendingSoftware";
import P2PLendingHero from "./P2PLendingHero";
import P2PLendingPlat from "./P2PLendingPlat";
import CustomLPlat from "./CustomLPlat";

function P2PLending() {
  return (
    <div>
      <Header />
      <P2PLendingHero />
      <LendingSoftware />
      <P2PLendingPlat />
      <CustomLPlat />
      <Footer />
    </div>
  );
}

export default P2PLending;
